module.exports = __webpack_public_path__ + "0c7c687a50c2a93b4deb909d251ec41c.png";